import { Directive, inject, OnInit } from '@angular/core';
import { MenuService } from '../services/menu/menu.service';
import { ActivatedRoute } from '@angular/router';
import { Menu } from '../models/menu';
import { DestroyBase } from './destroy-component-base';

@Directive()
export class MenuComponentBase extends DestroyBase implements OnInit {
  menuService = inject(MenuService);
  route = inject(ActivatedRoute);

  ngOnInit(): void {
    const segments = this.route.snapshot.url.map((segment) => segment.path);
    const path = segments.join('/');
    if (path) {
      const menuItem = this.menuService.getMenuItem(path);
      if (menuItem) {
        this.menuService.menuOnChange(menuItem);
      } else {
        this.menuService.menuOnChange(new Menu());
      }
    }
  }
}
